import type { OthersEvent, User } from "@liveblocks/client"

import { useRepository } from "../../app/services/repository"

export function useFilterOutSuperAdmins(others: OthersEvent["others"]) {
  const authorIds = useRepository().authors.map((author) => author.id)

  return others.filter((other) => authorIds.includes(other.id ?? ""))
}

export function useSelfIfNotSuperAdmin(self: User | undefined) {
  const authorIds = useRepository().authors.map((author) => author.id)

  return authorIds.includes(self?.id ?? "") ? self : undefined
}
